import React, {useEffect, useState} from "react";
import {UserApi} from "../../../../utils/UserApi";
import {Link} from "react-router-dom";
import {
    Alert,
    Card,
    FormControlLabel,Snackbar,
    Switch, Typography
} from "@mui/material";
import {styled} from '@mui/material/styles';
import styles from "../../../../assets/css/page.module.scss";
import CustomTable from "../../../../components/subComponents/Table" ;



const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({theme}) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
                theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === 'light' ? '#d32f2f' : '#39393D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

const UserList = props => {
    const [rowState, setRowState] = useState([]);
    const [openSnackBar1, setOpenSnackBar1] = React.useState(false);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleClickSnackBar1 = (text) => {
        setOpenSnackBar1(true);
        setMessage(text);
    };
    const handleCloseSnackBar1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar1(false);
    };
    const activateUser = async (id) => {
        setLoading(true);
        const response = result => {
            handleClickSnackBar1("کاربر مورد نظر با موفقیت فعال شد!");
            fetchData();
            setLoading(false);

        }
        const error = e => {

        }

        await UserApi.activateUser(id, response, error);
    }

    const deactivateUser = async (id) => {
        setLoading(true);

        const response = result => {
            handleClickSnackBar1("کاربر مورد نظر با موفقیت غیر فعال شد!")
            setLoading(false);
            fetchData();
        }
        const error = e => {

        }

        await UserApi.deactivateUser(id, response, error);
    }

    const headers= [
        {
            field: 'name', title: 'نام', width: 250, renderCell: (row) => (
                <div>
                    <Link to={`/admin/user/${row.id}`}>{row.name}</Link>
                </div>
            ),
        },
        {
            field: 'mail', title: 'پست الکترونیک', width: 250,
            align:'center',
            renderCell: (row) => (
                <Typography variant="body1" className={styles.mail}>
                    {row.mail}
                </Typography>)
        },
        {
            field: 'phone', title: 'تلفن همراه', width: 150,
            align:'center',
            renderCell: (row) => (
                <Typography variant="body1" className={styles.mail}>
                    {row.phone}
                </Typography>)
        },




        {
            field: 'userStatus', title: 'وضعیت کابری', width: 400,
            align:'right',
            renderCell: (row) => (
                <>
                    <FormControlLabel
                        className={styles.switch}
                        control={<IOSSwitch sx={{m: 1}}
                                            defaultChecked={parseInt(row.active) === 1 ? true : false}
                                            onChange={e => {
                                                if (e.target.checked)
                                                    activateUser(row.id);
                                                else deactivateUser(row.id);
                                            }}
                        />}
                        label=""
                    />

                </>)
        },


    ];

    const fetchData = async () => {
        setLoading(true);
        const response = (result) => {
            setRowState(result.data);
            setLoading(false)
        };

        const error = (e) => {

        };
        await UserApi.getAllUser(null, response, error);

    }
    useEffect( () => {
         (async () => {
            await fetchData();
        })();

    }, [])
    return <div style={{ padding: 15}}>
        <Card elevation={3} style={{height: 'calc(100vh - 30px)', direction: "rtl", overflow: "hidden"}}>
            <div className={styles.container}>
                <CustomTable headers={headers} rows={rowState} loading={loading} bottom={0}/>

            </div>
        </Card>
        <Snackbar open={openSnackBar1} autoHideDuration={2000}
                  onClose={handleCloseSnackBar1}
                  className={styles.snackBar}
                  anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        >
            <Alert
                severity="success"
                className={styles.txt}
            >
                {message}
            </Alert>
        </Snackbar>
    </div>;
};

export default UserList;
